import type { TextareaField as TextareaFieldSchema } from "shared"
import styles from "./TextAreaField.module.scss"

type Props = {
  field: TextareaFieldSchema
  value: string
  onChange: (value: string) => void
}

export function TextAreaField({ field, value, onChange }: Props) {
  return (
    <div className={styles.textareaField}>
      <label className={styles.commentLabel} htmlFor={field.id}>
        {field.label}
      </label>
      <textarea
        id={field.id}
        name={field.id}
        className={styles.textarea}
        maxLength={field.maxLength}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}
